<app-page-title [breadcrumbItems]="breadCrumbItems" title="Dashboard"></app-page-title>
<div class="mb-4">
  <div class="row align-items-center mb-4 text-center text-lg-start">
    <!-- Title -->
    <div class="col-12 col-lg-8">
      <h2 class="text-dark fs-4 mt-3 mb-3 mb-lg-0">
        {{ translatedPeriodLabel?.title }}
        {{ 'COMPANIES.OVERVIEW' | translate }}
      </h2>
    </div>

    <!-- Filter -->
    <div class="col-12 col-lg-4">
      <div class="d-flex align-items-center gap-2 justify-content-end">
        <label class="form-label p-0 m-0">{{ 'DASHBOARD.SORTBY' | translate }}</label>
        <div class="w-75">
          <ng-select
            (change)="clientsOverviewFilter($event)"
            [formControl]="periodControl"
            [items]="period"
            [searchable]="false"
            bindLabel="name"
            bindValue="id"
          >
            <ng-option *ngFor="let pageOption of period" [value]="pageOption.id">
              {{ pageOption.name }}
            </ng-option>
          </ng-select>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-xl-4">
      <card
        [isLoading]="isLoading"
        [period]="translatedPeriodLabel?.period"
        [popoverDesc]="translateService.instant('DASHBOARD.CLIENTSADDED_DESC')"
        [popoverTitle]="translateService.instant('DASHBOARD.CLIENTSADDED')"
        [profitType]="clientsOverview['changeClients']?.direction"
        [profit]="clientsOverview['changeClients']?.percent"
        [title]="translateService.instant('DASHBOARD.CLIENTSADDED')"
        [value]="clientsOverview['clients']"
        icon="ri-user-add-fill"
      />
    </div>
    <div class="col-12 col-xl-4">
      <card
        [isLoading]="isLoading"
        [period]="translatedPeriodLabel?.period"
        [popoverDesc]="translateService.instant('DASHBOARD.CONTRACTSSIGNED_DESC')"
        [popoverTitle]="translateService.instant('DASHBOARD.CONTRACTSSIGNED')"
        [profitType]="clientsOverview['changeContracts']?.direction"
        [profit]="clientsOverview['changeContracts']?.percent"
        [title]="translateService.instant('DASHBOARD.CONTRACTSSIGNED')"
        [value]="clientsOverview['contracts']"
        icon="ri-user-follow-fill"
      />
    </div>
    <div class="col-12 col-xl-4">
      <card
        [isLoading]="isLoading"
        [period]="translatedPeriodLabel?.period"
        [popoverDesc]="translateService.instant('DASHBOARD.INVOICESENT_DESC')"
        [popoverTitle]="translateService.instant('DASHBOARD.INVOICESENT')"
        [profitType]="clientsOverview['changeInvoices']?.direction"
        [profit]="clientsOverview['changeInvoices']?.percent"
        [title]="translateService.instant('DASHBOARD.INVOICESENT')"
        [value]="clientsOverview['invoices']"
        icon="ri-send-plane-fill"
      />
    </div>
  </div>
</div>
<!-- end row -->

<div class="row">
  <div class="col-xl-8">
    <div class="card rounded-4">
      <div class="card-header align-items-center d-flex">
        <h4 class="card-title mb-0 flex-grow-1">{{ 'DASHBOARD.PAYMENTACTIVITY' | translate }}</h4>
        <div class="d-flex justify-content-end align-items-center col-lg-3 gap-2">
          <label class="form-label p-0 m-0">{{ 'YEAR' | translate }}</label>
          <div class="col-md-6">
            <ng-select
              (change)="paymentActivityFilter($event)"
              [clearable]="false"
              [ngModel]="2025"
              [searchable]="false"
              bindLabel="name"
              bindValue="id"
            >
              <ng-option *ngFor="let year of years" [value]="year.id">
                {{ year.name | translate }}
              </ng-option>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row gy-2">
          <div class="col-md-4">
            <h4 class="fs-22 mb-2 d-flex align-items-center gap-2">
              @if (isLoading) {
                <p-skeleton width="100px" height="35px"/>
              } @else {
                @if (!paymentActivity['paymentTotal'] && paymentActivity['paymentTotal'] != 0) {
                  -
                } @else {
                  {{ paymentActivity['paymentTotal'] | moneyFormat }}
                }
              }
              <span
                class="text-muted d-inline-block fs-17 align-middle ms-0 ms-sm-2">{{ 'DASHBOARD.TOTALINVOICEAMOUNT' | translate }}</span>
            </h4>
          </div>
          <div class="col-md-8">
            <div class="d-md-flex main-chart justify-content-end">
              <div class="px-4 border-end">
                <h4 class="text-primary fs-22 mb-2 d-flex align-items-center gap-2">
                  @if (isLoading) {
                    <p-skeleton width="100px" height="35px"/>
                  } @else {
                    @if (!paymentActivity['amountPaid'] && paymentActivity['amountPaid'] != 0) {
                      -
                    } @else {
                      {{ paymentActivity['amountPaid'] | moneyFormat }}
                    }
                  }
                  <span
                    class="text-muted d-inline-block fs-17 align-middle ms-0 ms-sm-2">{{ 'DASHBOARD.PAID' | translate }}</span>
                </h4>
              </div>
              <div class="ps-4">
                <h4 class="text-danger fs-22 mb-2 d-flex align-items-center gap-2">
                  @if (isLoading) {
                    <p-skeleton width="100px" height="35px"/>
                  } @else {
                    @if (!paymentActivity['amountUnpaid'] && paymentActivity['amountUnpaid'] != 0) {
                      -
                    } @else {
                      {{ paymentActivity['amountUnpaid'] | moneyFormat }}
                    }
                  }
                  <span
                    class="text-muted d-inline-block fs-17 align-middle ms-0 ms-sm-2">{{ 'DASHBOARD.UNPAID' | translate }}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>

        <apx-chart
          [chart]="stackedColumnChartOptions.chart"
          [colors]="stackedColumnChartOptions.colors"
          [dataLabels]="stackedColumnChartOptions.dataLabels"
          [fill]="stackedColumnChartOptions.fill"
          [grid]="stackedColumnChartOptions.grid"
          [legend]="stackedColumnChartOptions.legend"
          [plotOptions]="stackedColumnChartOptions.plotOptions"
          [series]="stackedColumnChartOptions.series"
          [xaxis]="stackedColumnChartOptions.xaxis">
        </apx-chart>
      </div>
    </div>
  </div>

  <div class="col-xl-4 mb-3">
    <div class="card rounded-4">
      <div class="card-header align-items-center d-flex py-3">
        <h4 class="card-title mb-0 flex-grow-1">{{ 'DASHBOARD.MONTHLY_STRUCTURE' | translate }}</h4>
        <!--        <div class="col-md-4 d-flex justify-content-end align-items-center gap-2">-->
        <!--          <label class="form-label p-0 m-0">{{ 'YEAR' | translate }}</label>-->
        <!--          <div class="col-lg-8">-->
        <!--            <ng-select-->
        <!--              (change)="paymentActivityFilter($event)"-->
        <!--              [clearable]="false"-->
        <!--              [searchable]="false"-->
        <!--              bindLabel="name"-->
        <!--              bindValue="id"-->
        <!--              [ngModel]="2025"-->
        <!--            >-->
        <!--              <ng-option *ngFor="let year of years" [value]="year.id">-->
        <!--                {{ year.name | translate }}-->
        <!--              </ng-option>-->
        <!--            </ng-select>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="card-body">
        <apx-chart
          *ngIf="structureWidget?.series?.length"
          [chart]="structureWidget.chart"
          [colors]="structureWidget.colors"
          [dataLabels]="structureWidget.dataLabels"
          [labels]="structureWidget.labels"
          [legend]="structureWidget.legend"
          [plotOptions]="structureWidget.plotOptions"
          [responsive]="structureWidget.responsive"
          [series]="structureWidget.series">
        </apx-chart>

        <div class="px-1">
          <div class="p-1 d-flex border-bottom">
            <p class="mb-0 w-50">
              <i class="las la-dot-circle fs-18 text-primary me-2"></i>
              {{ 'DASHBOARD.COLLECTED'| translate }}
            </p>
            <div class="w-50 d-flex align-items-center justify-content-end">
              <div class="d-flex justify-content-end" style="width: 60%">
                <span>{{ clientsOverview?.structure?.collected| moneyFormat }}</span>
              </div>
              <div class="d-flex justify-content-end" style="width: 40%">
                <span
                  [style]="getProfitStyle(clientsOverview?.structure?.collectedPercent?.direction)"
                  class="p-1 rounded fw-bolder d-flex align-items-center">
                    <i class="fs-20" [class]="!clientsOverview?.structure?.collectedPercent?.direction ? 'ri-arrow-right-down-line' : 'ri-arrow-right-up-line'"></i>
                    {{ clientsOverview?.structure?.collectedPercent?.percent }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-1 d-flex border-bottom">
            <p class="mb-0 w-50">
              <i class="las la-dot-circle fs-18 text-primary me-2"></i>
              {{ 'DASHBOARD.OUTSTANDING'| translate }}
            </p>
            <div class="w-50 d-flex align-items-center justify-content-end">
              <div class="d-flex justify-content-end" style="width: 60%">
                <span>{{ clientsOverview?.structure?.outstanding| moneyFormat }}</span>
              </div>
              <div class="d-flex justify-content-end" style="width: 40%">
                <span
                  [style]="getProfitStyle(clientsOverview?.structure?.outstandingPercent?.direction)"
                  class="p-1 rounded fw-bolder d-flex align-items-center">
                    <i class="fs-20" [class]="!clientsOverview?.structure?.outstandingPercent?.direction ? 'ri-arrow-right-down-line' : 'ri-arrow-right-up-line'"></i>
                  {{ clientsOverview?.structure?.outstandingPercent?.percent }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-1 d-flex border-bottom">
            <p class="mb-0 w-50">
              <i class="las la-dot-circle fs-18 text-primary me-2"></i>
              {{ 'DASHBOARD.BALANCE'| translate }}
            </p>
            <div class="w-50 d-flex align-items-center justify-content-end">
              <div class="d-flex justify-content-end" style="width: 60%">
                <span>{{ clientsOverview?.structure?.balance| moneyFormat }}</span>
              </div>
              <div class="d-flex justify-content-end" style="width: 40%">
                <span
                  [style]="getProfitStyle(clientsOverview?.structure?.balancePercent?.direction)"
                  class="p-1 rounded fw-bolder d-flex align-items-center">
                    <i class="fs-20" [class]="!clientsOverview?.structure?.balancePercent?.direction ? 'ri-arrow-right-down-line' : 'ri-arrow-right-up-line'"></i>
                  {{ clientsOverview?.structure?.balancePercent?.percent }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- end row -->

<div class="row">
  <div class="col-xl-12">
    <div class="card">
      <div class="card-header border-0 align-items-center d-flex">
        <h4 class="card-title mb-0 flex-grow-1">{{ 'DASHBOARD.INCOICELIST' | translate }}</h4>
        <div class="d-flex align-items-center col-lg-3 gap-2">
          <label class="form-label p-0 m-0">{{ 'DASHBOARD.SORTBY' | translate }}</label>
          <div style="width: 85%; min-width: 200px">
            <ng-select
              (change)="invoiceFilter($event)"
              [searchable]="false"
              bindLabel="name"
              bindValue="id"
            >
              <ng-option *ngFor="let pageOption of period" [value]="pageOption.id">
                {{ pageOption.name | translate }}
              </ng-option>
            </ng-select>
          </div>
        </div>
      </div>
      <p-table
        [columns]="invoiceTableFields"
        [hasEdit]="false"
        [hasView]="false"
        [paginator]="false"
        [scrollHeight]="'calc(111vh - 420px)'"
        [value]="invoices"
        tableStyleClass="table table-hover custom-table"
      >
        <ng-template #cells let-data>
          @for (col of invoiceTableFields; track col) {
            <td>
                  <span class="p-datatable-column-title">
                      @if (col.iconClass) {
                        <i [class]="col.iconClass"></i>
                      }
                    {{ (col.label ?? col.fieldName) | translate }}
                  </span>
              @switch (col.fieldName) {
                @case ('actions') {
                  <div class="d-flex align-items-center gap-2">
                    <a
                      (click)="onView(data?.id)"
                      ngbTooltip="{{'VIEW'|translate}}"
                      class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center action-button">
                      <i class="las la-info-circle fs-20"></i>
                    </a>
                    <a
                      (click)="download(data)"
                      ngbTooltip="{{ 'DOWNLOAD' | translate }}"
                      class="btn btn-sm btn-outline-info d-flex align-items-center justify-content-center action-button">
                      <i class="las la-file-download fs-20"></i>
                    </a>
                    <a
                      (click)="delete(data?.id)"
                      ngbTooltip="{{ 'DELETE' | translate }}"
                      class="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center action-button">
                      <i class="las la-trash fs-20"></i>
                    </a>
                  </div>
                }
                @default {
                  <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
                }
              }
            </td>
          }
        </ng-template>

      </p-table>
    </div>
  </div>
</div>
<!-- end row -->
